import React, { useState } from 'react';
import { campaignObjectives } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';

const CreateCampaign = (props) => {
  const dispatch = useDispatch();
  const { accountId } = props;

  const { loadingCreateCampaign } = useSelector((state) => state.general);

  const campaignDataInitialState = { special_ad_categories: [] };
  const [campaignData, setCampaignData] = useState(campaignDataInitialState);
  return (
    <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <h5>Create A Campaign</h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 p-4'>
        <div className='col-lg-8 d-flex justify-content-center mt-4 pt-lg-0'>
          <input
            type='text'
            className='form-control'
            placeholder='Campaign Name'
            style={{ textAlign: 'center' }}
            value={campaignData.name}
            onChange={(e) => setCampaignData({ ...campaignData, name: e.target.value })}
          />
        </div>
        <div className='col-lg-6 d-flex justify-content-center mt-4 pt-lg-0'>
          <select
            type='text'
            className='form-control'
            value={campaignData.objective}
            onChange={(e) => setCampaignData({ ...campaignData, status: e.target.value })}
          >
            <option value={null}>Select a Status</option>
            <option value='ACTIVE'>ACTIVE</option>
            <option value='PAUSED'>PAUSED</option>
          </select>
        </div>
        <div className='col-lg-6 d-flex justify-content-center mt-4 pt-lg-0'>
          <select
            type='text'
            className='form-control'
            value={campaignData.objective}
            onChange={(e) => setCampaignData({ ...campaignData, objective: e.target.value })}
          >
            <option value={null}>Select an Objective</option>
            {campaignObjectives.map((objective) => (
              <option key={objective} value={objective}>
                {objective}
              </option>
            ))}
          </select>
        </div>
        {campaignData.name && campaignData.objective && campaignData.status ? (
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
            <button
              className='btn btn-primary'
              disabled={loadingCreateCampaign}
              onClick={() => {
                dispatch(generalSet({ reduxField: 'loadingCreateCampaign', value: true }));
                dispatch(
                  apiAction({
                    reduxField: 'campaigns',
                    route: 'accountDashboard/createFacebookCampaign',
                    accountId,
                    campaignData,
                    addToArray: true,
                    setLoading: 'loadingCreateCampaign',
                  })
                );
                setCampaignData(campaignDataInitialState);
              }}
            >
              Create Campaign
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CreateCampaign;
